module.exports = __webpack_public_path__ + "img/ont.00a8e89b.svg";